/* Hero slideshow — the only scripted motion on the home page.
   Opacity crossfade (600ms, in CSS), 7s auto-advance, pauses on hover and on focus.
   prefers-reduced-motion disables the auto-advance entirely; the crossfade is disabled
   in theme.css. Every string the viewer reads is already in the DOM, one per slide, so
   this file never builds copy. */
(function () {
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Hero(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    this.counts = Array.prototype.slice.call(root.querySelectorAll('[data-hero-count]'));
    this.interval = parseInt(root.dataset.heroInterval, 10) || 7000;
    this.index = 0;
    this.timer = null;

    if (this.slides.length < 2) return;

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        this.show(i);
        this.restart();
      }.bind(this));
    }.bind(this));

    /* The photograph is the swipe surface, not the whole hero: a swipe that starts on the
       headline or the button should do nothing. Any manual move restarts the timer, so the
       auto-advance never fires immediately after a deliberate one. */
    var self = this;
    /* Every slide's figure, not the first: the figure is emitted inside the block loop, so
       binding root.querySelector('.hero__figure') put the only touch control inside slide 1,
       which goes inert the moment the carousel advances. galleryNav's navReady guard makes
       the repeat call idempotent, and inert keeps the off-slides out of the tab ring. */
    if (window.galleryNav) {
      Array.prototype.forEach.call(root.querySelectorAll('.hero__figure'), function (surface) {
        window.galleryNav(surface, {
          label: root.dataset.heroGroupLabel || 'Slides',
          prev: function () { self.show(self.index - 1); self.restart(); },
          next: function () { self.show(self.index + 1); self.restart(); }
        });
      });
    }

    /* The dots sit under the photograph, outside galleryNav's surface, so a keypress on a
       focused dot never reached that listener: a tester tabbed to a visibly focused dot,
       pressed Right, and nothing moved. Same two keys, second landing spot. Focus follows
       the slide so the dot the reader is on is always the one that is lit. */
    var dotRow = root.querySelector('.hero__dots');
    if (dotRow) {
      dotRow.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self.show(self.index - 1); }
        else if (e.key === 'ArrowRight') { self.show(self.index + 1); }
        else { return; }
        e.preventDefault();
        if (self.dots[self.index]) self.dots[self.index].focus();
        self.restart();
      });
    }

    root.addEventListener('mouseenter', this.stop.bind(this));
    root.addEventListener('mouseleave', this.start.bind(this));
    root.addEventListener('focusin', this.stop.bind(this));
    root.addEventListener('focusout', this.start.bind(this));

    /* The only control that survives a touch device: hover-pause does not exist there and
       focus-pause is not discoverable. Held state is the viewer's, so it outranks hover
       and focus — start() refuses while it is set. */
    this.paused = false;
    this.toggle = root.querySelector('[data-hero-pause-toggle]');
    if (this.toggle) {
      this.toggle.addEventListener('click', function () {
        self.paused = !self.paused;
        self.toggle.setAttribute('aria-pressed', String(self.paused));
        self.toggle.textContent = self.paused
          ? (root.dataset.heroPlay || 'Play')
          : (root.dataset.heroPause || 'Pause');
        if (self.paused) { self.stop(); } else { self.start(true); }
      });
    }

    this.start();
  }

  Hero.prototype.show = function (next) {
    this.index = (next + this.slides.length) % this.slides.length;
    this.slides.forEach(function (slide, i) {
      var on = i === this.index;
      slide.classList.toggle('hero__slide--on', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) { slide.removeAttribute('inert'); } else { slide.setAttribute('inert', ''); }
    }.bind(this));
    this.dots.forEach(function (dot, i) {
      if (i === this.index) { dot.setAttribute('aria-current', 'true'); }
      else { dot.removeAttribute('aria-current'); }
    }.bind(this));
    this.counts.forEach(function (count, i) {
      count.hidden = i !== this.index;
    }.bind(this));
  };

  Hero.prototype.start = function (force) {
    if (REDUCE.matches || this.slides.length < 2 || this.paused) return;
    /* A dot click focuses the dot and leaves the pointer on the band, then calls restart()
       — so the act of using the control defeated both pause mechanisms and the slide the
       viewer had just chosen slid away seven seconds later. Pressing Play is the one case
       that overrides it: the pointer is on the band and the focus is on the button by
       definition, and the viewer has just asked for the motion back. */
    if (!force && (this.root.matches(':hover') || this.root.contains(document.activeElement))) return;
    this.stop();
    this.timer = setInterval(function () { this.show(this.index + 1); }.bind(this), this.interval);
    this.announce(false);
  };

  Hero.prototype.stop = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
    this.announce(true);
  };

  /* The counter is the theme's only live region. It is worth hearing after a deliberate
     move and worth nothing every seven seconds forever, so it is only live while the
     rotation is not running. */
  Hero.prototype.announce = function (live) {
    var count = this.root.querySelector('.hero__count');
    if (count) count.setAttribute('aria-live', live ? 'polite' : 'off');
  };

  Hero.prototype.restart = function () { this.stop(); this.start(); };

  function init(scope) {
    (scope || document).querySelectorAll('[data-hero]').forEach(function (root) {
      if (root.dataset.heroReady) return;
      root.dataset.heroReady = 'true';
      new Hero(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  init(document);
})();
